import React from "react";
import { company } from "../mock";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 py-10">
      <div className="mx-auto flex max-w-[1600px] flex-col items-center justify-between gap-4 px-6 md:flex-row md:px-12">
        <div className="flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-[#d4ff4e]" />
          <span className="font-display text-sm font-medium">{company.fullName}</span>
        </div>
        <p className="text-xs text-[#8a8a86]">
          © {company.year} {company.name}. All rights reserved.
        </p>
        <button
          onClick={() => (window.lenis ? window.lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" }))}
          className="link-underline text-xs uppercase tracking-widest text-[#c9c9c4] hover:text-white"
        >
          Back to top ↑
        </button>
      </div>
    </footer>
  );
}
